import moment from "moment"

export const getTime = (day: string) =>
  day ? moment(day).utc().format("HHmm") : ""
